import config from '../config';
import {
  authHeader,
  customFetch,
  commonRequestOptions,
  handleResponse,
  jsonHeader,
} from '../helpers';

const endpointPath = config.api.API_URL + '/entity_type';

export const entityTypeService = {
  getByGlossaryId,
  create,
  update,
  checkDestroy,
  destroy,
};

/**
 * Fetches all entity types for a given glossary.
 * @param {number|string} id - The glossary id.
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, entity_types: object[] }>}
 */
async function getByGlossaryId(id, signal) {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader() },
    ...commonRequestOptions(),
  };
  return customFetch(`${endpointPath}/glossary/${id}`, requestOptions, signal).then(handleResponse);
}

/**
 * Creates one or more entity types.
 * @param {{ entity_types: object[] }} items
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, message: string, entity_types: object[] }>}
 */
async function create(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(endpointPath, requestOptions, signal).then(handleResponse);
}

/**
 * Updates one or more entity types.
 * @param {{ entity_types: object[] }} items
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, message: string, entity_types: object[] }>}
 */
async function update(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(endpointPath, requestOptions, signal).then(handleResponse);
}

/**
 * Checks the impact of deleting one or more entity types.
 * @param {{ entity_types: object[] }} items
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, result: object[] }>}
 */
async function checkDestroy(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(`${endpointPath}/check_delete`, requestOptions, signal).then(handleResponse);
}

/**
 * Deletes one or more entity types.
 * @param {{ entity_types: object[] }} items
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, message: string, entity_types: object[] }>}
 */
async function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      ...jsonHeader(),
    },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(endpointPath, requestOptions, signal).then(handleResponse);
}
